import React, { useEffect, useState, useContext } from "react";
import "./TeacherCourses.css";
import { Bell } from "lucide-react";
import takeClassIcon from "../../assets/attendClassIcon.png";
import GradeProjectIcon from "../../assets/myProgressIcon.png";
import studentDashboardIcon from "../../assets/projectsActivitiesIcon.png";
import axios from "axios";
import { Link } from "react-router-dom";
import { UserContext } from "../UserContext";
import AttendClassModal from "../Navbars/AttendClassModal";
import Header from "../Header";

const TeacherCourses = ({ onSearch, searchValue }) => {
  const [courses, setCourses] = useState([]);
  const [search, setSearch] = useState(searchValue || "");
  const { userInfo, setUserInfo } = useContext(UserContext) || {};
  const [userType, setUserType] = useState("");
  const [isAttendClassModalOpen, setAttendClassModalOpen] = useState(false);
  const [selectedCourseForModal, setSelectedCourseForModal] = useState(null);

  useEffect(() => {
    if (!userInfo?.User_id) return;
    // Fetch courses for this teacher from backend
    axios
      .get(
        `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/getTeacherTaughtCourses`,
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        setCourses(res.data.courseInfo || []); // <-- Correct key here
      })
      .catch((err) => console.error(err));
  }, [userInfo?.User_id]);

  // Filter courses by search term
  const filteredCourses = (courses || []).filter((course) =>
    course.coursename?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="courses-background">
      <Header />
      <div className="courses-searchbar">
        <input
          type="text"
          placeholder="Search anything"
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
            if (onSearch) onSearch(e.target.value);
          }}
        />
      </div>

      <div className="courses-container">
        {filteredCourses.map((course) => (
          <div className="course--card" key={course.Course_id}>
            <h3 className="course-card-title">{course.coursename}</h3>
            <div className="course-card-links">
              <Link
                to={`/StudentDashboard/${course.Course_id}`}
                state={{
                  courseId: course.Course_id,
                  courseName: course.coursename,
                }}
                className="course-card-link-dashboard"
              >
                <img
                  src={studentDashboardIcon}
                  alt="Student Dashboard"
                  className="course-link-icon"
                />
                Student Dashboard
              </Link>
              <Link
                to={`/GradeProjectPage/${course.Course_id}`}
                state={{
                  courseId: course.Course_id,
                  courseName: course.coursename,
                }}
                className="course-card-link-projects"
              >
                <img
                  src={GradeProjectIcon}
                  alt="Grade Projects"
                  className="course-link-icon"
                />
                Grade Projects
              </Link>
              <button
                className="course-card-link-takeClass"
                onClick={() => {
                  setSelectedCourseForModal(course);
                  setAttendClassModalOpen(true);
                }}
              >
                <img
                  src={takeClassIcon}
                  alt="Take Class"
                  className="course-link-icon"
                />
                Take Class
              </button>
            </div>
          </div>
        ))}
      </div>
      {isAttendClassModalOpen && selectedCourseForModal && (
        <AttendClassModal
          isOpen={isAttendClassModalOpen}
          onClose={() => setAttendClassModalOpen(false)}
          classes={[selectedCourseForModal]} // expects an array
          selectedCourse={selectedCourseForModal.Course_id}
        />
      )}
    </div>
  );
};

export default TeacherCourses;